/**
 * La foto de perfil (26-09). El servidor guarda `user.foto` = «/api/auth/foto/<id>»; aquí se le
 * pone delante el backend, porque la app y la API no siempre van por el mismo dominio.
 * Sin foto, null: quien la pinta enseña la inicial, como siempre.
 */
const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

export const urlDeFoto = (user) => (user?.foto ? `${BACKEND}${user.foto}` : null);
